import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import AddMember from '@features/supplier/component/AddMember';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchTeamMembers, updateTeamMemberStatus } from '@services/supplierOnboardingService';

import { printApiError } from '@utils/Util';

const TeamManagement = () => {
	const [members, setMembers] = useState([]);
	const [isShowAdd, setIsShowAdd] = useState(false);
	const dispatch = useDispatch();
	const { id } = useParams();

	const getMembers = async () => {
		try {
			dispatch(openLoader());
			const data = await fetchTeamMembers(id);
			setMembers(data);
			dispatch(closeLoader());
		} catch (e) {
			dispatch(closeLoader());
			printApiError(e);
		}
	};

	useEffect(() => {
		(async () => {
			await getMembers();
		})();
	}, []);

	const toggleTeamMemberStatus = async (user) => {
		try {
			dispatch(openLoader());
			await updateTeamMemberStatus(user.id, user.status === 'ACTIVE' ? 'DISABLED' : 'ACTIVE');
			await getMembers();
			dispatch(closeLoader());
		} catch (e) {
			dispatch(closeLoader());
			printApiError(e);
		}
	};

	const onCloseModal = async (reload = false) => {
		if (reload === true) {
			await getMembers();
		}
		setIsShowAdd(false);
	};

	return (
		<>
			<div className="row">
				<div className="col-md-12">
					<div className="team-managment ">
						{members.length > 0 && (
							<>
								<div className="managment-head d-flex justify-content-between align-items-center">
									<p className="gray_dark_02 regular-12">Team Member</p>
									<button className="button outline" onClick={() => setIsShowAdd(true)}>
										<img
											src={`${process.env.PUBLIC_URL}/icons/add-round-white24.svg`}
											alt="delete"
										/>
										<span className="ml-1 regular-12 gray_dark_01">Add Member</span>
									</button>
								</div>
								<table className="table team-managmet-table with-border hover">
									<thead>
										<tr>
											<th className="weight-500 regular-12">SL</th>
											<th className="weight-500 regular-12">Team Member</th>
											<th className="weight-500 regular-12">Phone Number</th>
											<th className="weight-500 regular-12">Email</th>
											<th className="weight-500 regular-12">Designation</th>
											<th className="weight-500 regular-12">Action</th>
										</tr>
									</thead>
									<tbody>
										{members?.map((item, index) => (
											<tr key={`member_${item.id}`}>
												<td>{index + 1}</td>
												<td>{item.name}</td>
												<td>{item.phone}</td>
												<td>{item.email}</td>
												<td>{item.designation}</td>
												<td>
													<div className="option">
														<div className="dropdown">
															<button
																className="btn btn-default dropdown-toggle"
																type="button"
																id="menu1"
																data-toggle="dropdown"
																aria-expanded="false"
															>
																<img
																	src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`}
																	alt="delete"
																/>
															</button>
															<ul
																className="dropdown-menu dropdown-menu-right shadow-lg"
																role="menu"
																aria-labelledby="menu1"
															>
																<li
																	role="presentation"
																	className="px-4 pb-3 pt-3"
																	onClick={() =>
																		toggleTeamMemberStatus(item)
																	}
																>
																	<a
																		role="menuitem"
																		tabIndex={-1}
																		className="font-weight-normal  text-black"
																	>
																		{item.status === 'ACTIVE'
																			? 'Deactivate'
																			: 'Activate'}
																	</a>
																</li>
															</ul>
														</div>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</>
						)}
						{members.length === 0 && (
							<div className="empity-button text-center">
								<p className="pb-2 gray_dark_03 weight-500 regular-16">No member found</p>
								<button className="button outline" onClick={() => setIsShowAdd(true)}>
									<img
										src={`${process.env.PUBLIC_URL}/icons/add-round-white24.svg`}
										alt="delete"
									/>
									<span className="ml-1 regular-12 gray_dark_01">Add Member</span>
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
			{isShowAdd && <AddMember onClose={onCloseModal} />}
		</>
	);
};

export default TeamManagement;
